// Import all the channels to be used by Action Cable
import RenderJobChannel from "./render_job_channel"
import MusicVideoChannel from "./music_video_channel"
import "./scripted_video_channel"

// Expose for inline scripts
window.RenderJobChannel = RenderJobChannel
window.MusicVideoChannel = MusicVideoChannel
